import React from 'react';
import { Link as RouterLink } from 'react-router';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Link } from '@/types/serviceGroup';
import { Hover } from '@/components/shared/Animation';
import { AlertMessage } from '@/components/pages/Service/Detail/shared/Presentation/AlertMessage';

type Props = {
  subscribeUrl: Link | null;
  showMemberWarning: boolean;
};

export const Actions: React.FC<Props> = ({
  subscribeUrl,
  showMemberWarning,
}) => {
  const { t } = useTranslation();
  return (
    <ActionsWrapper>
      {showMemberWarning && (
        <AlertMessage content={t('text.subscription.memberWarning')} />
      )}
      {subscribeUrl && <SubscriptionButton link={subscribeUrl} />}
    </ActionsWrapper>
  );
};

const ActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-right: 24px;
    margin-bottom: 24px;
  }
`;

const SubscriptionButton: React.FC<{ link: Link }> = ({
  link: { url, label },
}) => {
  return url.startsWith('http') ? (
    <a href={url} rel="noopener noreferrer" target="_blank">
      <PrimaryButton>{label}</PrimaryButton>
    </a>
  ) : (
    <RouterLink to={url}>
      <PrimaryButton>{label}</PrimaryButton>
    </RouterLink>
  );
};

const PrimaryButton = styled(Hover)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 339px;
  height: 54px;
  border-radius: 4px;
  box-shadow: 0px 2px 10px rgba(110, 110, 110, 0.12);
  font-size: 16px;
  font-weight: bold;
  background-color: #1847c7;
  color: #fff;
`;
